interface Scripts {
  name: string;
  src: string;
}
export const ScriptStore: Scripts[] = [{ name: 'maps', src: 'https://maps.googleapis.com/maps/api/js?key=$CLIENT_KEY$' }];
